import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import { loyaltyRewardsReducer, loyaltyRewardsSaga } from './ducks/loyalty-rewards';
import { ratings, rootSaga as ratingsSaga, FETCH_RATINGS, RESET as RATINGS_RESET } from './ducks/rating';
import { rootSaga as shoppingListSaga } from './ducks/shopping-list';
import {
  rootSaga as productsByIdsSaga,
  productsByIds,
  FETCH_PRODUCTS_BY_IDS,
  RESET as PRODUCTS_BY_ID_RESET,
} from './ducks/products-by-ids';
import {
  rootSaga as sponsoredProductsSaga,
  sponsoredProducts,
  FETCH_SPONSORED_PRODUCTS,
  RESET as SPONSORED_PRODUCTS_RESET,
  isFallback,
  SET_FALLBACK as SPONSORED_PRODUCTS_SET_FALLBACK,
} from './ducks/sponsored-products';

export const products = combineReducers({
  ratings,
  productsByIds,
  sponsoredProducts,
  loyaltyRewards: loyaltyRewardsReducer,
  isFallback,
});

export const productsActions = {
  FETCH_RATINGS,
  RATINGS_RESET,
  FETCH_PRODUCTS_BY_IDS,
  PRODUCTS_BY_ID_RESET,
  FETCH_SPONSORED_PRODUCTS,
  SPONSORED_PRODUCTS_RESET,
  SPONSORED_PRODUCTS_SET_FALLBACK,
};

export { FETCH_RATINGS, FETCH_PRODUCTS_BY_IDS, FETCH_SPONSORED_PRODUCTS, SPONSORED_PRODUCTS_SET_FALLBACK };

export * from './ducks/selectors';
export * from './components/product';
export * from './types';

export function* productsRootSaga(): unknown {
  return yield all([
    ratingsSaga(),
    shoppingListSaga(),
    productsByIdsSaga(),
    sponsoredProductsSaga(),
    loyaltyRewardsSaga(),
  ]);
}
